import React, {useContext, useEffect, useState} from 'react';
import {customToast, DisabledContext, FormInput, Icons, Modal, Variants} from "toolbox-react-frontend-components";
import {route} from "ziggy-js";
import {cloneDeep} from "lodash";

const EditSettingModal = (props) => {
    const {
        setting,
        onClose     = () => {},
        onSuccess   = () => {},
    } = props;

    const {
        disabled,
        setDisabled
    } = useContext(DisabledContext);

    const [clonedSetting, setClonedSetting]         = useState(null);
    const [errors, setErrors]                       = useState(null);
    const [updating, setUpdating]                   = useState(false)

    useEffect(() => {
        setClonedSetting(cloneDeep(setting));
    }, [setting]);

    useEffect(() => {
        if (updating) {
            handleUpdate();
        }
    }, [updating]);

    const handleClose = () => {
        setClonedSetting(null);
        setErrors(null);

        onClose();
    }

    const handleUpdate = () => {
        setDisabled(true);
        setErrors(null);

        axios.patch(route('api.admin.setting.update', {setting: clonedSetting.id}), clonedSetting)
            .then((response) => {
                customToast({
                    title:      'Setting updated.',
                    variant:    Variants.Success
                });

                setDisabled(false);
                setUpdating(false);

                onSuccess();
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.message) {
                        customToast({
                            title: error.response.data.message,
                            variant: Variants.Danger
                        });
                    }

                    if (!!error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }

                    setUpdating(false);
                    setDisabled(false);
                } else {
                    console.log(error);
                    customToast({
                        title:      'An error occurred. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            });
    }

    const updateField = (fieldName, value) => {
        let clone = cloneDeep(clonedSetting);

        clone[fieldName] = value;

        setClonedSetting(clone);
    }

    return (
        <Modal
            open={!!clonedSetting}
            title={'Edit Setting'}
            icon={Icons.EDIT}
            confirmText={'Update'}
            onConfirm={() => setUpdating(true)}
            closeText={'Cancel'}
            onClose={() => handleClose()}
            disabled={disabled || updating}
            variant={Variants.Primary}
        >
            {!!clonedSetting && (
                <>
                    <FormInput
                        type={'textarea'}
                        label={clonedSetting.label}
                        name={'value'}
                        value={clonedSetting.value ?? ''}
                        errorMessages={!!errors && !!errors.value ? errors.value : null}
                        onChange={(value) => updateField('value', value)}
                        disabled={updating || disabled}
                    />
                </>
            )}
        </Modal>
    );
}

export default EditSettingModal;
